module.exports = __webpack_public_path__ + "img/wallet.6eb7a1ef.svg";